<template>
  <div class="antpay">
    <van-popup class="pay-type" v-model="selectPayType" :close-on-click-overlay="false">
      <van-nav-bar left-arrow left-text="取消" @click-left="typeClose" style="width: 280px;">
        <div class="pay-nav-bar" slot="title">
          <div class="text">需要支付</div>
          <div class="num">{{ paynum }}</div>
        </div>
      </van-nav-bar>
      <van-cell-group>
        <van-cell clickable @click="onPayTypeChange('blcPay')" is-link>
          <div class="text-con" slot="title">
            <img class="pay-icon" src="./img/antpay.png" alt="">
            <span class="pay-btn-type">奖金余额 <span class="availableAmount">(￥{{ availableAmount.toFixed(2) }})</span></span>
          </div>
        </van-cell>
        <van-cell clickable @click="onPayTypeChange('wxJSAPI')" is-link>
          <div class="text-con" slot="title">
            <img class="pay-icon" src="./img/wxpay.png" alt="">
            <span class="pay-btn-type">微信支付</span>
          </div>
        </van-cell>
      </van-cell-group>
    </van-popup>

    <van-popup v-model="Cshow" position="bottom" class="van-popup-pass" :close-on-click-overlay="false">
      <div class="van-popup-pass" >
        <van-nav-bar title="支付密码" left-arrow left-text="取消" @click-left="close"/>
        <van-password-input :value="password"/>
        <van-number-keyboard :show="true" @input="onInput" @delete="onDelete"/>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getCashWallet } from '@/api/wallet/cash'
export default {
  components: {
  },
  props: {
    payData: {
      required: false
    },
    paynum: {// 显示在标题中的金额
      // type: String,
      required: false,
      default: '￥0.00'
    },
    show: {
      type: Boolean,
      required: false,
      default: true
    },
    showPayType: { // 是否显示支付方式
      type: Boolean,
      required: false,
      default: false
    },
    customClose: {//是否自定义关闭
      required: false,
    }
  },
  data (){
    return {
      availableAmount: 0,
      selectPayType: false, // 是否展示支付方式
      Cshow: false,
      password: '',// 输入的密码
      payType: 'blcPay', // 付款方式(aliPay:支付宝, wxPay:微信, wxH5Pay:微信H5, wxJSAPI:微信JS支付 blcPay:现金余额，antPay:金币余额) ,
    }
  },
  watch: {
    show () {
      if(this.show){ // 展示支付密码
        this.password = '';
        this.payType = 'blcPay';
        if(this.showPayType){ //是否展示支付方式
          this.myBalance();//查询钱余额
          this.selectPayType = true
        }else {
          this.Cshow = true
        }
      }else { //隐藏支付密码
        this.Cshow = false
      }
    }
  },
  created (){

  },
  methods: {
    //点击模态框关闭密码窗
    close(){
      if(this.customClose){
        this.$emit('close', {'isShow': true});
      }else {
        this.Cshow = false;
        this.$emit('close');
      }
    },
    // 关闭支付方式模态框
    typeClose(){
      if(this.customClose){
        this.$emit('close', {'isShow': true});
      }else {
        this.selectPayType = false;
        this.$emit('close');
      }
    },

    //选择支付方式
    onPayTypeChange(type){
      this.payType = type
      if(type==='blcPay'){ // 支付方式为余额支付
        console.log(this.payData, this.availableAmount)
        if(this.payData.amount > this.availableAmount){
          this.$toast('奖金余额不足，请选择请他支付方式！')
          return false
        }
        this.selectPayType = false
        this.Cshow = true
      }else { //支付方式为微信支付
        this.selectPayType = false
        let data = this.payData || {};
        data.payType = this.payType
        console.log(data)
        this.$emit('onPay',data)

        // this.$emit('onPay',{
        //   payType: this.payType,// 支付方式
        //   amount: this.payData.amount,// 购买数量
        //   money: this.payData.money,// 支付金额
        //   userOpenId: this.payData.userOpenId,// 支付金额
        //   walletAccount: this.payData.walletAccount,// 支付金额
        // });
        // this.$toast('微信支付')
      }
    },

    //数字键
    onInput(key){
      this.password = (this.password + key).slice(0, 6);
      if(this.password.length===6){
        this.$toast.loading({
          mask: true,
          duration: 0,
          message: '正在支付...'
        });

        let data = this.payData || {};
        data.payPassword = this.password;
        if(this.showPayType){
          data.payType = this.payType;
        }
        console.log(data)
        this.$emit('onPay',data)
      }
    },

    // 删除键
    onDelete(){
      this.password = this.password.slice(0, this.password.length - 1);
    },

    //外部调用 内部关闭密码窗方法
    $close(tip){
      this.$toast.clear();
      this.selectPayType = false;
      this.$emit('close');
      if(tip && typeof tip === 'string'){
        this.$toast(tip)
      }
    },
    //外部调用 内部关闭密码窗方法---成功时
    $success(tip){
      this.$toast.clear();
      this.$emit('close');
      if(tip && typeof tip === 'string'){
        this.$toast.success(tip)
      }
    },

    $customClose(){
      this.Cshow = false;
      this.selectPayType = false;
    },
    //查询现金余额
    myBalance(){
      getCashWallet({userOpenid: this.session('userOpenId'), walletType:0}).then(res => {
        if(res.code===200){
          this.availableAmount = res.data.availableAmount
        }
      })
    }



  },

}
</script>

<style lang="less" scoped>
.antpay{
  .van-nav-bar {
    .van-nav-bar__left{
      left: 6px;
      .van-icon{
        color: #1989fa!important;
        font-size: 12px!important;
      }
    }
    .van-nav-bar__title{
      .pay-nav-bar{
        /*display: flex;*/
        font-size: 13px;
        line-height: 1;
        .text{
          font-size: 16px;
          line-height: 30px;
        }
        .num{
          color: #e17f01;
        }
      }
    }
  }
  .pay-type{
    .van-cell-group{
      padding: 8px 0;
      .text-con{
        display: flex;align-items: center;
        .pay-icon{
          width: 19px;
          height: 19px;
          display: inline-flex;
        }
        .pay-btn-type{
          display: inline-flex;
          padding-left: 8px;
        }
      }


      .availableAmount{
        padding-left: 8px;
        font-size: 13px;
        color: #e17f01;
      }
    }
  }
  .van-popup-pass{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 366px;
    background-color: #fff;
    .pay-text{
      font-size: 14px;
      padding: 8px 16px;
    }
    .van-radio-group{
      padding: 0 12px 16px;
      background-color: white;
      font-size: 16px;
      .van-cell{
        padding: 6px 15px;
      }
    }
    .van-password-input{
      width: 344px;
      border-right: 1px solid rgba(0,0,0,.2);
      .van-hairline{
        border: 1px solid rgba(0,0,0,.2);
        border-right: 0px solid rgba(0,0,0,.2);
      }
    }

  }
}
[class*=van-hairline]::after{
  border: 1px solid #ededed;
}
</style>